module.exports = __webpack_public_path__ + "img/plus-icon-black.svg";